import { call, put, takeLatest, delay, select } from 'redux-saga/effects';

import {
	getOrdersBtb,
	getOrdersBtbFailure,
	getOrdersBtbSuccess,
	getOrderBtbById,
	getOrderBtbByIdFailure,
	getOrderBtbByIdSuccess,
	createOrderBtb,
	createOrderBtbFailure,
	createOrderBtbSuccess,
	finalizeOrderBtb,
	finalizeOrderBtbFailure,
	finalizeOrderBtbSuccess,
	unfullfillOrderBtb,
	unfullfillOrderBtbFailure,
	unfullfillOrderBtbSuccess,
	downloadCsv,
	downloadCsvFailure,
	downloadCsvSuccess,
	getOrderStatuses,
	getOrderStatusesFailure,
	getOrderStatusesSuccess,
	dispatchOrdersBtb,
	dispatchOrdersBtbFailure,
	dispatchOrdersBtbSuccess,
} from '.';

import orderBtbService from '../../../services/OrderBtbService';

function* rootSaga() {
	yield takeLatest(getOrdersBtb, getOrdersBtbSaga);
	yield takeLatest(getOrderBtbById, getOrderBtbByIdSaga);
	yield takeLatest(createOrderBtb, createOrderBtbSaga);
	yield takeLatest(finalizeOrderBtb, finalizeOrderBtbSaga);
	yield takeLatest(unfullfillOrderBtb, unfullfillOrderBtbSaga);
	yield takeLatest(downloadCsv, downloadCsvSaga);
	yield takeLatest(getOrderStatuses, getOrderStatusesSaga);
	yield takeLatest(dispatchOrdersBtb, dispatchOrdersBtbSaga);
}

function* getOrdersBtbSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(orderBtbService.getAll.bind(orderBtbService), payload);
		yield put(getOrdersBtbSuccess(response));
	} catch (error) {
		yield put(getOrdersBtbFailure(error));
	}
}

function* getOrderBtbByIdSaga({ payload }) {
	const orderId = payload;
	try {
		yield delay(300);
		const response = yield call(orderBtbService.getById.bind(orderBtbService), orderId);
		yield put(getOrderBtbByIdSuccess(response));
	} catch (error) {
		yield put(getOrderBtbByIdFailure(error));
	}
}

function* createOrderBtbSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(orderBtbService.create.bind(orderBtbService), payload);
		yield put(createOrderBtbSuccess(response));

		// Refreshing the ordersBtb list since we created one:
		const tableParams = yield select(({ ordersBtb }) => ordersBtb.ordersBtb.tableParams);
		yield put(getOrdersBtb(tableParams));
	} catch (error) {
		yield put(createOrderBtbFailure(error));
	}
}

function* dispatchOrdersBtbSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(orderBtbService.dispatch.bind(orderBtbService), payload);
		yield put(dispatchOrdersBtbSuccess(response));

		// Refreshing the ordersBtb list since we dispatched some:
		const tableParams = yield select(({ ordersBtb }) => ordersBtb.ordersBtb.tableParams);
		yield put(getOrdersBtb(tableParams));
	} catch (error) {
		yield put(dispatchOrdersBtbFailure(error));
	}
}

function* finalizeOrderBtbSaga({ payload }) {
	const { orderBtbId: id, data: orderBtbForm } = payload;
	try {
		yield delay(300);
		const response = yield call(orderBtbService.finalize.bind(orderBtbService), id, orderBtbForm);
		yield put(finalizeOrderBtbSuccess(response));

		// Refreshing the ordersBtb list since we finalized one:
		const tableParams = yield select(({ ordersBtb }) => ordersBtb.ordersBtb.tableParams);
		yield put(getOrdersBtb(tableParams));

		// Refreshing the orderBtb details since we finalized one:
		const { id: selectedOrderId } = yield select(({ ordersBtb }) => ordersBtb.orderBtb.data);
		if (id == selectedOrderId) {
			yield put(getOrderBtbById(id));
		}
	} catch (error) {
		yield put(finalizeOrderBtbFailure(error));
	}
}

function* unfullfillOrderBtbSaga({ payload }) {
	const { orderBtbId: id, data: orderBtbForm } = payload;
	try {
		yield delay(300);
		const response = yield call(orderBtbService.unfullfill.bind(orderBtbService), id, orderBtbForm);
		yield put(unfullfillOrderBtbSuccess(response));

		// Refreshing the ordersBtb list since we unfullfilled one:
		const tableParams = yield select(({ ordersBtb }) => ordersBtb.ordersBtb.tableParams);
		yield put(getOrdersBtb(tableParams));

		// Refreshing the orderBtb details since we unfullfilled one:
		const { id: selectedOrderId } = yield select(({ ordersBtb }) => ordersBtb.orderBtb.data);
		if (id == selectedOrderId) {
			yield put(getOrderBtbById(id));
		}
	} catch (error) {
		yield put(unfullfillOrderBtbFailure(error));
	}
}

function* downloadCsvSaga({ payload }) {
	try {
		yield delay(300);
		yield call(orderBtbService.downloadCsv.bind(orderBtbService), payload);
		yield put(downloadCsvSuccess());
	} catch (error) {
		yield put(downloadCsvFailure(error));
	}
}

function* getOrderStatusesSaga() {
	try {
		yield delay(300);
		const response = yield call(orderBtbService.getOrderStatuses.bind(orderBtbService));
		yield put(getOrderStatusesSuccess(response));
	} catch (error) {
		yield put(getOrderStatusesFailure(error));
	}
}

export default rootSaga;
